import { Toaster } from "@/components/ui/sonner";
import ConditionalLayout from "@/components/ConditionalLayout";
import { FileManagerProvider } from "@/components/fileManager";
import { SSEProvider } from "@/components/SSEProvider";
import RouteStoreSync from "@/components/RouteStoreSync";
import { Outlet } from "react-router-dom";

export default function StoreLayout() {
  return (
    <FileManagerProvider>
      <SSEProvider>
        <RouteStoreSync />
        <ConditionalLayout>
          <Outlet />
        </ConditionalLayout>
        <Toaster
          toastOptions={{
            classNames: {
              error:
                "bg-notification-error text-white border border-notification-error",
              success:
                "bg-notification-success text-white border border-notification-success",
              info: "bg-notification-warning text-white border border-notification-warning",
            },
          }}
        />
      </SSEProvider>
    </FileManagerProvider>
  );
}
